/**
 * Mozne security chybi pri autorizaci pozadavku. Kontrola se provadi na strane SSF FE. Tyto chybi neprichazi z MEP,
 * ale jsou detekovany zde ve front end.
 *
 * Viz: https://drive.google.com/file/d/0B3KxDK7A5VTPeUtoMlEya3VZLU0/view
 * Viz take AuthorizationDialogComponent.
 */
export enum AuthorizationSecurityError {
    ORIGIN_NOT_SAME = 'ORIGIN_NOT_SAME',
    MEP_ID_NOT_SAME = 'MEP_ID_NOT_SAME'
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/model/authorization/authorization-security-error.enum.ts